var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"https://yandex.ru/map-widget/v1/?um=constructor%3Ac202d39c10dcf0cd522039d059b6db5c759363407110ec14977d75435ee9049a&source=constructor","width":"100%","height":"300","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }